import { useMemo } from 'react';
import { GENERAL_DEPARTMENT_ID } from '@battleops/shared';
import { useDepartments } from '../context/DepartmentContext';
import { useTasks } from '../context/TaskContext';

/**
 * The department a task being captured lands in (v0.1.242, shared/deptinfer.js) and the hand pick over it — phone and
 * web capture share it. draft = { title, tags, projectId, departmentId? } or null; picked: undefined = the guess, else
 * an id (null = General). → { shown: { departmentId, confidence, why, source } | null, stamp: fields for addTask
 * (the pick + `_deptPicked`, which teaches the learned layer), guess }.
 */
export function useDeptDraft(draft, picked) {
  const { departmentActive } = useDepartments();
  const { guessDepartment } = useTasks();
  const key = draft ? `${draft.title || ''}|${(draft.tags || []).join(',')}|${draft.projectId || ''}|${draft.departmentId === undefined ? '~' : draft.departmentId}` : '';
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const guess = useMemo(() => (departmentActive && draft && !draft.parentId && guessDepartment ? guessDepartment(draft) : null), [key, departmentActive, guessDepartment]);
  if (!guess) return { shown: null, stamp: {}, guess: null };
  if (picked === undefined || guess.source === 'lock') return { shown: guess, stamp: {}, guess };
  const id = picked || GENERAL_DEPARTMENT_ID;
  return {
    shown: { departmentId: id, confidence: 'high', why: 'Picked', source: 'given' },
    stamp: { departmentId: picked || null, _deptPicked: id === guess.departmentId ? 'pick' : 'correction' },
    guess,
  };
}
